import type { ResolveProceduralDateResult } from '../../../../../backend/src/matter/procedural-timeline/date-resolution';

interface CalculatorLegendProps {
  result: ResolveProceduralDateResult;
}

export function CalculatorLegend({ result }: CalculatorLegendProps) {
  return (
    <div className="grid grid-cols-3 gap-y-1 text-xs text-gray-600">
      {result.startDateExcluded && <LegendSwatch className="bg-gray-900" label="Start (excluded)" />}
      <LegendSwatch className="bg-violet-100" label="Counted day" />
      {!result.weekendsCount && <LegendSwatch className="border border-gray-200 bg-white" label="Skipped weekend" />}
      {!result.publicHolidaysCount && (
        <LegendSwatch className="border border-rose-200 bg-white" label="Skipped holiday" />
      )}
      <LegendSwatch className="bg-teal-100" label="Calculated date" />
      <LegendSwatch className="bg-white ring-2 ring-teal-600 ring-inset" label="Selected date" />
    </div>
  );
}

function LegendSwatch({ className, label }: { className: string; label: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className={`inline-block h-3.5 w-3.5 rounded-sm ${className}`} />
      <span>{label}</span>
    </div>
  );
}
